// Mouse drag for horizontal scroll rows ([data-drag-scroll]): touch already scrolls them,
// a mouse cannot. Buttons and links inside still work; a real drag cancels the click.
(() => {
  const THRESHOLD = 6;
  const init = (track) => {
    if (track.dataset.dragReady) return;
    track.dataset.dragReady = '1';
    let startX = 0; let startLeft = 0; let dragged = false; let active = false;
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      active = true; dragged = false; startX = event.clientX; startLeft = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });
    track.addEventListener('pointermove', (event) => {
      if (!active) return;
      const delta = event.clientX - startX;
      if (!dragged && Math.abs(delta) < THRESHOLD) return;
      if (!dragged) { dragged = true; track.setPointerCapture(event.pointerId); track.classList.add('is-dragging'); }
      track.scrollLeft = startLeft - delta;
      event.preventDefault();
    });
    const stop = (event) => {
      if (!active) return;
      active = false;
      track.style.removeProperty('scroll-snap-type');
      if (dragged && event.pointerId !== undefined && track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      window.setTimeout(() => track.classList.remove('is-dragging'), 0);
    };
    track.addEventListener('pointerup', stop);
    track.addEventListener('pointercancel', stop);
    track.addEventListener('click', (event) => { if (dragged) { event.preventDefault(); event.stopPropagation(); } }, true);
    track.addEventListener('dragstart', (event) => event.preventDefault());
  };
  const scan = () => document.querySelectorAll('[data-drag-scroll]').forEach(init);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
